import { Injectable } from '@angular/core';

@Injectable()
export class DomainService {

  constructor() { }

  public getRootDomain() {
    var i = 0, domain = document.domain, p = domain.split('.'), s = "_gd" + (new Date()).getTime();
    while (i < (p.length - 1) && document.cookie.indexOf(s + '=' + s) === -1) {
        domain = p.slice(-1 - (++i)).join('.');
        document.cookie = s + "=" + s + ";domain=" + domain + ";";
    }
    document.cookie = s + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=" + domain + ";";
    return domain;
  }

  public isSsl() {
    return document.location.protocol === "https:";
  }

}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/domain.service.ts